export default __webpack_public_path__ + "static/media/logo_image.840aa595.png";